import Vue from 'vue'
import VueRouter from 'vue-router'

// Containers
 const DefaultContainer = () => import('@/containers/DefaultContainer')

//Dashboard
const Dashboard = () => import("@/views/Dashboard");

//Pesagem
const Pesagem = () => import("@/views/Pesagem/Pesagem");
const ListaPesagem = () => import("@/views/Pesagem/ListaPesagem");

//Fechamentos
const Fechamentos = () => import("@/views/Fechamento/Fechamento");

//Usuarios:
const Usuarios = () => import('@/views/Usuarios/Usuarios')
const NovoUsuario = () => import('@/views/Usuarios/NovoUsuario')

//CentroDeCusto
const CentroCusto = () => import('@/views/CentroCusto/CentroCusto')
const NovoCentroCusto = () => import('@/views/CentroCusto/NovoCentroCusto')

//clientes
const Cliente = () => import('@/views/Cliente/Cliente')
const NovoCliente = () => import('@/views/Cliente/NovoCliente')

//Relatorio
const RelatorioGeral = () => import('@/views/Relatorios/Geral')

//Configurações Balanca
const Balanca = () => import('@/views/Configuracao/Balanca')
const NovaBalanca = () => import('@/views/Configuracao/NovaBalanca')

// Views - Pages
const LoginP = () => import("@/views/pages/Login");
const Page404T = () => import('@/views/pages/Page404')
const Page500T = () => import('@/views/pages/Page500')
const Page403T = () => import('@/views/pages/Page403')
const EsqueciSenha = () => import('@/views/pages/EsqueciSenha')

Vue.use(VueRouter)


export default new VueRouter({
  mode: "hash",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0  }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: 'pesagem',
          name: 'Pesagem',
          component: Pesagem,
          meta: { 
            requiresAuth: true
          }
        },
        //ultimas pesagems
        {
          path: 'pesagens',
          meta: {
            label: 'Pesagens',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/pesagens/1',
              component: ListaPesagem,
            },
            {
              path: ':id',
              component: ListaPesagem,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        //fechamentos
        {
          path: 'fechamentos',
          meta: {
            label: 'Fechamentos',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/fechamentos/1',
              component: Fechamentos,
            },
            {
              path: ':id',
              component: Fechamentos,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        {
          path: 'fechamento',
          meta: { 
            label: 'Fechamentos',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/fechamentos/1',
              component: Fechamentos,
              meta: { 
                requiresAuth: true,
              }
            }
          ]
        },
        //USUARIO
        {
          path: 'usuarios',
          meta: {
            label: 'Usuários',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/usuarios/1',
              component: Usuarios,
            },
            {
              path: ':id',
              component: Usuarios,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        {
          path: 'usuario',
          meta: { 
            label: 'Usuário',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/usuarios/1',
              component: Usuarios,
              meta: { 
                requiresAuth: true,
              }
            },
            {
              path: 'editar/:id',
              name: 'Editar usuário',
              component: NovoUsuario,
              meta: { 
                requiresAuth: true,
              }
            },
            {
              path: 'novo',
              name: 'Novo usuário',
              component: NovoUsuario,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        //CENTRO DE CUSTO
        {
          path: 'centro-de-custos',
          meta: {
            label: 'Centro de Custos',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/centro-de-custos/1',
              component: CentroCusto,
            },
            {
              path: ':id',
              component: CentroCusto,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        {
          path: 'centro-de-custo',
          meta: { 
            label: 'Centro de Custo',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/centro-de-custos/1',
              component: CentroCusto,
              meta: { 
                requiresAuth: true,
              }
            },
            {
              path: 'editar/:id',
              name: 'Editar centro de custo',
              component: NovoCentroCusto,
              meta: { 
                requiresAuth: true,
              }
            },
            {
              path: 'novo',
              name: 'Novo centro de custo',
              component: NovoCentroCusto,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        //balanca config
        {
          path: 'configuracoes',
          meta: {
            label: 'Balanças',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/configuracoes/1',
              component: Balanca,
            },
            {
              path: ':id',
              component: Balanca,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        {
          path: 'configuracao',
          meta: { 
            label: 'Balanças',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/configuracoes/1',
              component: Balanca,
              meta: { 
                requiresAuth: true,
              }
            },
            {
              path: 'editar/:id',
              name: 'Editar balança',
              component: NovaBalanca,
              meta: { 
                requiresAuth: true,
              }
            },
            {
              path: 'novo',
              name: 'Nova balança',
              component: NovaBalanca,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        //Cliente
        {
          path: 'clientes',
          meta: {
            label: 'Clientes',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/clientes/1',
              component: Cliente,
            },
            {
              path: ':id',
              component: Cliente,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        {
          path: 'cliente',
          meta: { 
            label: 'Clientes',
            requiresAuth: true,
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              redirect: '/clientes/1',
              component: Cliente,
              meta: { 
                requiresAuth: true,
              }
            },
            {
              path: 'editar/:id',
              name: 'Editar cliente',
              component: NovoCliente,
              meta: { 
                requiresAuth: true,
              }
            },
            {
              path: 'novo',
              name: 'Novo Cliente',
              component: NovoCliente,
              meta: { 
                requiresAuth: true,
              }
            },
          ]
        },
        //RELATORIOS
        {
          path: 'relatorios',
          name: 'Relatórios',
          redirect: '/dashboard',
          component: {
            render (c) { return c('router-view') }
          },          
          meta: { 
            requiresAuth: true,
          },
          children: [
            {
              path: 'geral',
              component: RelatorioGeral,
              meta: { 
                label: 'Relatório Geral',
                requiresAuth: true,
              }
            },
          ]
        }
      ],
      
    },
    {
      path: '/',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404T',
          component: Page404T
        },
        {
          path: '500',
          name: 'Page500T',
          component: Page500T
        },
        {
          path: '403',
          name: 'Page403T',
          component: Page403T
        },        
        {
          path: 'login',
          name: 'Login',
          component: LoginP,
        }
        ,
        {
          path: 'esqueci-senha',
          name: 'Esqueci minha senha',
          component: EsqueciSenha,
          children: [
            {
              path: ':id',
              name: 'Trocar senha',
              component: EsqueciSenha
            },
          ]
        }        
      ]
    }
    ]
  });

